"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ColorRectangle.types.js.map